<div class="modal fade" tabindex="-1" role="dialog" #newUserDialog>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="title">
          <h4 class="modal-title">Новый пользователь</h4>
        </div>
      </div>
      <div class="modal-body">
        <user-form
          (onSaveAccount)="onSaveAccount($event)"
          (onSaveRole)="onSaveRole($event)"
          (onAllSaved)="onAllSaved()"
          [account]="account"
          [phoneEnabled]="true"
          [roleEnabled]="roleEnabled"
          [role]="role"
          [forceRoleSave]="true"
        ></user-form>
      </div>
    </div>
  </div>
</div>
